import React from "react";
import PropTypes from "prop-types";
import { Form as CoreForm } from "@sparefoot/react-commons";
import { FormProvider } from "react-hook-form";
import useFormTracking from "hooks/tracking/useFormTracking";

/**
 * THIS FORM IS ONLY TO BE USED WITH RHF-ENABLED INPUTS
 * LIKE THE ONES IN FormFields.js
 */

const Form = ({ children, methods, onSubmit, formName, ...rest }) => {
	// prepare segment props
	const { handleSubmit } = useFormTracking({ onSubmit, id: formName });

	return (
		<FormProvider {...methods}>
			<CoreForm
				onSubmit={methods.handleSubmit(handleSubmit)}
				{...rest}
			>
				{children}
			</CoreForm>
		</FormProvider>
	);
};

Form.propTypes = {
	methods: PropTypes.object.isRequired,
	formName: PropTypes.string,
	children: PropTypes.node,
	onSubmit: PropTypes.func.isRequired
};

export default Form;
